export default __webpack_public_path__ + "static/media/icon_skill_tech.2595bf78.png";